<span [ngClass]="classes()" [matTooltip]="tooltip()">
  @if (isValueNumeric()) {
    {{ numericDisplayValue() }}
  } @else {
    {{ value() }}
  }
</span>
